<template>
    <b-card-code
        title="Edit Project" 
    >
          <!-- form -->
          <validation-observer
            ref="ProjectEditForm"
            #default="{invalid}"      
          >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="editProject"
          >

                <!-- Organization-->
                <b-form-group
                  v-if="is_staff"
                  label="Organization"
                  label-for="Organization">
                    <validation-provider
                      #default="{ errors }"
                      name="organization"
                      rules="required">
                        <b-form-select  
                        v-model="organization" 
                        :options="organizations"
                        :state="errors.length > 0 ? false:null"
                        ></b-form-select>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>



                <!-- Asset Name -->
                <b-form-group
                  label="Project Name"
                  label-for="Project Name">
                    
                    <validation-provider
                      #default="{ errors }"
                      name="project_name"
                      rules="required">
                        <b-form-input
                          id="project_name"
                          v-model="project_name"
                          :state="errors.length > 0 ? false:null"
                          name="project_name"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>


                <b-button
                  type="submit"
                  variant="primary"
                  :disabled="invalid"
                >
                  Update
                </b-button>
            </b-form>
          </validation-observer>

  </b-card-code>
</template>
<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BForm, BButton,BFormTextarea, BInputGroupAppend,BInputGroup, BFormSelect, BFormCheckbox
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
export default {
  components: {
    BCardCode,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BRow,
    BButton,
    BCol, 
    ValidationProvider,
    ValidationObserver,
    BInputGroupAppend,
    BInputGroup,
    BFormSelect,
    BFormCheckbox
  },
  data() {
    return {
      is_staff:this.$store.state.app.user.is_staff,
      project_name:"",
      organization: "",
      organizations:[{ value: null, text: '--Select Organization--' }],
    }
  },
    created: function () {
     this.load();
  },
    methods: {

        load: function(){
          
          if(this.is_staff){
            // Load oragnization drop down
            const o_options = {
                method: 'GET',
                headers: { 'content-type': 'application/json' },
                url: process.env.VUE_APP_BASEURL+'organization/organization/',
            }
            var self = this;
            this.$http(o_options).then( ( res ) => {
                // console.log(res.data)
                res.data.map(function(value, key) {
                    let org = {
                        value: res.data[key].org_id, 
                        text: res.data[key].org_name
                        };
                    // console.log(res.data[key].profile.organization)
                    self.organizations.push(org)
                });
            })
          }



            // Load values for edit
        const options = {
            method: 'GET',
            headers: { 'content-type': 'application/json' },
            url:  process.env.VUE_APP_BASEURL+'client/project/projects/'+this.$route.params.id+"/",
          }
          this.$http(options).then( ( res ) => {
              console.log(res)

              this.project_name = res.data.project_name
              this.organization = res.data.organization
              // Load user dropdown based on the organization
                    
            } )



        },

        editProject: function() {
            this.$refs.ProjectEditForm.validate().then(success => {
            if (success) {
            //call to axios
            // if(!this.is_staff)
                let data = {
                    project_name: this.project_name,
                    organization: this.organization
                }
                const options = {
                method: 'PATCH',
                headers: { 'content-type': 'application/json' },
                data:data,
                url: process.env.VUE_APP_BASEURL+'client/project/projects/'+this.$route.params.id+"/",
                }
                this.$http(options).then( ( res ) => {
                    console.log(res)
                    if(res.data.project_id){
                        this.$router.push({name: 'projects_list'});
                    }
                })
            }  
         })
      }
    
    }
  }
  </script>